import React from "react";

const BookAnAppointment = ({ data }) => {
  const { link } = data;
  return (
    <div className="flex flex-col items-center justify-center rounded-2xl py-8 text-white lg:flex-row">
      <div className="px-4 lg:w-8/12 lg:basis-8/12">
        <h3 className="mb-6 text-center font-openSans text-3xl font-bold capitalize text-white lg:text-left">
          What makes us a #1 diabetes
          <br />
          specialities centre in India?
        </h3>
        <p className="text-center font-openSans text-lg lg:text-left">
          When you turn to DMDSC, you’re choosing the best diabetes treatment
          solutions. Below are some numbers that speak volumes about our centre:
        </p>
      </div>
      <div className="relative mt-4 px-4 lg:mt-0 lg:w-4/12 lg:basis-4/12">
        <a
          href={link}
          target="_blank"
          rel="noreferrer"
          className=" cursor-pointer rounded-lg border border-white bg-white px-6 py-3 font-openSans text-lg uppercase text-primary transition-all duration-500 hover:bg-white hover:text-secondary lg:px-20 lg:py-6"
        >
          Book Appointment
        </a>
      </div>
    </div>
  );
};

export default BookAnAppointment;
